import { API } from '../../../common/api'
import { labravAWSEngineServiceUrl } from '../../../common/utils/constants'

export const fetchPartnerIqTableData = (
  partnerId: string,
  sortBy?: string,
  sortOrder?: 'asc' | 'desc',
  segment?: string,
  icpFitMin?: number,
  icpFitMax?: number,
  title?: string,
  contactName?: string,
  location?: string
) =>
  API.get(`${labravAWSEngineServiceUrl}/partners/${partnerId}/contacts`, {
    params: {
      sort_by: sortBy,
      sort_order: sortOrder,
      segment: segment,
      icp_fit_min: icpFitMin,
      icp_fit_max: icpFitMax,
      title: title,
      contact_name: contactName,
      location: location,
    },
  })

export const fetchPartnerIqOverviewData = (partnerId: string) =>
  API.get(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/contacts/overview`
  )

export const putPartnerIqIcpFormData = (partnerId: string, data: object) =>
  API.put(`${labravAWSEngineServiceUrl}/partners/${partnerId}/icp`, data)

export const fetchPartnerIqIcpFormData = (partnerId: string) =>
  API.get(`${labravAWSEngineServiceUrl}/partners/${partnerId}/icp`)

export const fetchPartnerIqProfileData = (
  partnerId: string,
  contactId: string
) =>
  API.get(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/contacts/${contactId}/profile`
  )

export const fetchPartnerIqSegments = (partnerId: string) =>
  API.get(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/contacts/segments`
  )

export const fetchPartnerIqTableReport = (
  partnerId: string,
  page?: number,
  pageSize?: number,
  sortBy?: string,
  sortOrder?: 'asc' | 'desc',
  segment?: string,
  icpFitMin?: number,
  icpFitMax?: number,
  contactName?: string,
  title?: string,
  location?: string
) =>
  API.get(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/contacts/download`,
    {
      params: {
        page: page,
        page_size: pageSize,
        sort_by: sortBy,
        sort_order: sortOrder,
        segment: segment,
        icp_fit_min: icpFitMin,
        icp_fit_max: icpFitMax,
        contact_name: contactName,
        title: title,
        location: location,
      },
      responseType: 'blob',
    }
  )

export const fetchPartnerIqOpportunitiesReport = (
  partnerId: string,
  contactId: string
) =>
  API.get(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/contacts/${contactId}/opportunities/download`,
    {
      responseType: 'blob',
    }
  )

/** Collab Room / Admin Panel page data (company info, trusted by, metrics, etc.) */
export const fetchCollabRoomPageData = (partnerId: string) =>
  API.get(`${labravAWSEngineServiceUrl}/partners/${partnerId}/partner_info/`)

/** Create partner info (POST when no data exists yet) */
export const createCollabRoomPageData = (
  partnerId: string,
  data: Record<string, unknown>
) =>
  API.post(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/partner_info/`,
    data
  )

/** Send a collab room invite for a contact */
export const postCollabInvite = (
  partnerId: string,
  contactId: string,
  userId: string
) =>
  API.post(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/contacts/${contactId}/collab-invite`,
    { user_id: userId }
  )

/** Update partner info (PUT when data already exists) */
export const saveCollabRoomPageData = (
  partnerId: string,
  data: Record<string, unknown>
) =>
  API.put(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/partner_info/`,
    data
  )
